import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService as ResourceApiService } from '../../resource/utilities/services/api.service';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AppInitializerService } from '@app/app-initializer.service';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { PopupComponent } from '@app/components/popup/popup.component';
import { CourseFormsComponent } from '../course-forms/course-forms.component';
import { ApiService } from '../utilities/services/api.service';

@Component({
	selector: 'app-course-progress',
	templateUrl: './course-progress.component.html',
	styleUrls: ['./course-progress.component.scss']
})
export class CourseProgressComponent implements OnInit {

	showCourseList = true;
	popupRef;
	actualResourceID;
	resourceDetail;
	moduleList = [];
	loader = true;
	readStateLoader = true;
	contentData: {
		type: 'resource' | 'takeTest',
		data: any
	};
	lastData;
	userData;
	scoredPercentage;
	constructor(
		public gfService: GlobalFunctionService,
		private resourceApiService: ResourceApiService,
		private baseService: BaseService,
		public locale: LocaleService,
		public detectDevice: DetectDeviceService,
		private cdref: ChangeDetectorRef,
		private popup: MatDialog,
		private apiService: ApiService
	) {

	}

	ngOnInit(): void {
		this.loader = true;
		if (this.detectDevice.resolutionState$.value.deviceType === 'mobile') {
			this.showCourseList = false;
		}
		this.getCourseDetails();
		// console.log(this.userData, 'userdata hit>>>>>', this.userData.userID)
	}

	getCourseDetails() {
		this.loader = true;
		const headers = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.resourceApiService
			.detail(Number(this.actualResourceID), headers)
			.subscribe(
				(response) => {
					if (response) {
						this.resourceDetail = response;
						if (this.resourceDetail && this.resourceDetail.hasOwnProperty('infoFields')) {
							if (Array.isArray(this.resourceDetail.infoFields.courseModules)) {
								this.dataBuild();
								this.moduleList = this.resourceDetail.infoFields.courseModules;
							}
						}
						if (this.contentData && this.contentData.type && this.contentData.type === 'resource') {
							// this.referenceDetail(this.contentData);
						} else {
							this.loader = false;
						}
					} else {
						this.loader = false;
						this.gfService.openSnackBar('ERROR', {
							message: this.locale.translate('no_data_found'),
							icon: 'clear',
							position: 'before'
						});
					}
				},
				(error) => {
					this.loader = false;
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
			.add(() => {
				this.getReadStatus();
				this.getScoredPercatege();
				this.loader = false;
			})
	}
	getReadStatus() {
		const headers: any = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.resourceApiService.getResourceReadStatus(this.actualResourceID, headers, this.userData.userID).subscribe(
			(response) => {
				if (response) {
					// console.log(response, 'response>>>>>>>')
					if (this.resourceDetail) {
						this.resourceDetail.read = response.read;
						this.resourceDetail.lastTimeline = response.lastTimeline;
						this.resourceDetail.completedPercent = response.completedPercent;
						this.resourceDetail.moduleReadData = response.course;
						if (this.moduleList && this.moduleList.length && this.resourceDetail && this.resourceDetail.moduleReadData) {
							Object.keys(this.resourceDetail.moduleReadData).map(key => {
								if (key) {
									const moduleData = this.moduleList.find(items => items.moduleID === Number(key));
									if (moduleData && moduleData.activites && moduleData.activites.length) {
										if (this.resourceDetail.moduleReadData[key] && this.resourceDetail.moduleReadData[key].length) {
											for (const data of this.resourceDetail.moduleReadData[key]) {
												let matchKey;
												if (data.resourceID) {
													matchKey = 'resourceID';
												} else if (data.assessmentID) {
													matchKey = 'assessmentID';
												}
												const activity = moduleData.activites.find(items => items.id === data[matchKey]);
												if (activity) {
													activity.read = data.read;
													activity.completedPercent = data.completedPercent;
												}
											}
										}
									}
								}
							});
						}
						// this.updatePercentage(true);
					}
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.readStateLoader = false;
				this.cdref.detectChanges();
			});

	}

	getScoredPercatege() {
		this.loader = true;
		const headers = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.apiService.getScoredPercentageUser(Number(this.actualResourceID), headers, this.userData.userID).subscribe(
			(response) => {
				if (response) {
					this.scoredPercentage = response.scoredPercentage;
				}
			}, (error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			})
			.add(() => {
				this.loader = false;
			});
	}

	dataBuild() {
		for (const data of this.resourceDetail.infoFields.courseModules) {
			data.opened = false;
			if (data.activites && data.activites.length) {
				// delete data.activites[1].resourceFormat;
				// delete data.activites[2].resourceFormat;
				// data.activites[1].id = 579;
				// data.activites[2].id = 571;
				for (const activity of data.activites) {
					activity.selected = false;
					activity.contentType = this.baseService.referenceType('courseContentType', activity.type);
					if (activity.resourceFormat) {
						activity.resourceFormat = this.baseService.referenceType('resourceFormat', activity.resourceFormat);
					}
					if (activity.resourceTypeID) {
						activity.resourceTypeID = this.baseService.referenceType('resourceType', activity.resourceTypeID);
					}
				}
				if (!this.lastData) {
					data.activites[0].selected = true;
					data.opened = false;
					if (data.activites[0].type === 'AT') {
						this.contentData = {
							type: 'takeTest',
							data: data.activites[0].id
						};
					} else {
						this.contentData = {
							type: 'resource',
							data: data.activites[0]
						};
					}
					this.lastData = data.activites[0];
				}
			} else {
				data.activites = [];
			}
			if (data.references && data.references.length) {
				const references = [];
				for (const record of data.references) {
					const cardData: ContentImageCard = {
						title: record.title,
						date: this.gfService.dateFormat(record.createdAt, 'MMM d, y'),
						thumbnail: ''
					};
					if (record.description) {
						cardData.description = record.description;
					}
					if (record.resource.thumbnail) {
						cardData.thumbnail = record.resource.thumbnail;
					}
					if (record.resourceFormat) {
						record.resourceFormat = this.baseService.referenceType('resourceFormat', record.resourceFormat);
						cardData.format = record.resourceFormat.key;
						if (cardData.thumbnail === '') {
							cardData.thumbnail = record.resourceFormat.image;
						}
					}
					record.resourceTypeID = this.baseService.referenceType('resourceType', record.resourceTypeID);
					if (record.resourceTypeID) {
						cardData.type = record.resourceTypeID.caption;
					}
					const extraData = {
						resourceID: record.resourceID,
						createdBy: record.createdBy
					};
					references.push(this.gfService.JSONMerge(cardData, extraData));
				}
				data.references = references;
			} else {
				data.references = [];
			}
		}
	}

	viewAssesmentResult(result) {
		if (result?.read) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				autoFocus: false,
				data: {
					action: 'dynamic',
					popup: true,
					component: CourseFormsComponent,
					componentData: [
						{
							variableName: 'action',
							value: 'viewAssesmentResult'
						},
						{
							variableName: 'viewResultDetails',
							value: result
						},
						{
							variableName: 'userData',
							value: this.userData
						}
					]
				},
				disableClose: true,
				maxWidth: '860px'
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result && typeof result === 'object') {
				}
			});
		}

	} 

	viewScormReport(result) {
		if (result?.read) {
			if (result?.resourceTypeID && result.resourceTypeID.value && Number(result.resourceTypeID.value) === 15 ) {
				const dialogRef = this.popup.open(PopupComponent, {
					panelClass: ['custom-panel'],
					autoFocus: false,
					data: {
						action: 'dynamic',
						popup: true,
						component: CourseFormsComponent,
						componentData: [
							{
								variableName: 'action',
								value: 'viewScormReport'
							},
							{
								variableName: 'viewScormData',
								value: result
							},
							{
								variableName: 'userData',
								value: this.userData
							}
						]
					},
					disableClose: true,
					maxWidth: '860px'
				});
				dialogRef.afterClosed().subscribe(async (result) => {
					if (result && typeof result === 'object') {
					}
				});
			}
		}
		
	}
}
